import React, { useState, useRef, useEffect } from 'react';
import './css/Podcast.css';
import './css/typography.css';
import './css/layout.css';
import './css/Popup.css';
import { FaPlay, FaPause, FaVolumeUp } from 'react-icons/fa';

import majesteImage from './image/image-son/majeste.webp';
import résistanceImage from './image/image-son/Résistance.webp';
import voyageurImage from './image/image-son/Voyageur.webp';
import transmetteurImage from './image/image-son/Transmetteur.webp';
import passionImage from './image/image-son/passion2.webp';
import artisantImage from './image/image-son/artisant.webp';
import libanaiseImage from './image/image-son/Yusra.webp';
import amoureuxImage from './image/image-son/amoureux.webp';
import transhumanceImage from './image/image-son/transhumance.webp';
import cairnImage from './image/image-son/cairn.webp';
import feuImage from './image/image-son/feu.webp';
import au26Image from './image/image-son/au26.webp';

import audioFileforet from './music/Sa_majesté_la_forêt.mp3';
import audioFilerésistance from './music/Résistance.mp3';
import audioFilevoyageur from './music/Voyageur.mp3';
import audioFiletransmetteur from './music/Transmetteur.mp3';
import audioFilepassion from './music/Passion.mp3';
import audioFileartisant from './music/artisant.mp3';
import audioFilelibanaise from './music/libanaise.mp3';
import audioFileamoureux from './music/amoureux.mp3';
import audioFiletranshumance from './music/Transhumances.mp3';
import audioFilefeu from './music/Feu.mp3';
import audioFilecairn from './music/cairn.mp3';
import audioFileau26 from './music/au26.mp3';

const SoundExample = () => {
  const [playingIndex, setPlayingIndex] = useState(null);
  const [progress, setProgress] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [volume, setVolume] = useState(1);
  const [showVolumeControl, setShowVolumeControl] = useState(false);
  const [popupVisible, setPopupVisible] = useState(false);
  const [popupContent, setPopupContent] = useState("");
  const audioRef = useRef(null);
  const volumeHideTimeoutRef = useRef(null);

  // Association des tags popup aux descriptions
  const popupDescriptions = {
    "@atelierlesbuissoniers": {
      title: "Les Buissoniers",
      content: "La Buissonière est un accueil de jour pour personnes atteintes d’Alzheimer. J’ai interviewé certains d’entre eux afin de choisir des profils et les présenter à une classe de collègiens. Les adolescents ont enregistré les sons servant à la composition finale et les voix, les souvenirs des “seigneurs” comme ils les appellent. L’idée étant d’évoquer ou illustrer certains passages de leur vie."
    }
  };

  const soundExamples = [
    { title: 'Transhumance', image: transhumanceImage, audioPath: audioFiletranshumance, text: 'Le voyage des bergers et de leurs troupeaux.' },
    { title: 'Au26', image: au26Image, audioPath: audioFileau26, text: 'Exploration de la notion de "chez-soi" à travers des captations sonores et témoignages d’habitants' },
    { title: 'Cairn', image: cairnImage, audioPath: audioFilecairn, text: 'Récits de festivaliers autour de la perte et de la transmission' },

    { title: 'Sa majesté la forêt', image: majesteImage, audioPath: audioFileforet, text: 'Conversation d’oiseaux, les plumes s’écartent laissant place à sa majesté la forêt. .' },
    { title: 'La résistante', image: résistanceImage, audioPath: audioFilerésistance, text: 'Histoire d’une résistante Bretonne @atelierlesbuissoniers' },
    { title: 'Le voyageur', image: voyageurImage, audioPath: audioFilevoyageur, text: 'Balade dans un jardin japonais Les rosiers sont en fleurs. @atelierlesbuissoniers' },
    { title: 'Le transmetteur', image: transmetteurImage, audioPath: audioFiletransmetteur, text: 'Un prof toulousain et une histoire familiale <br /> "Ò Tolosa, mon país aux tèrras tant aimadas". @atelierlesbuissoniers' },
    { title: 'La passionnée', image: passionImage, audioPath: audioFilepassion, text: 'Ascension d’une montagne<br /> Conversation au lavoire <br /> Conseillère Sociale @atelierlesbuissoniers' },
    { title: 'L’artisan', image: artisantImage, audioPath: audioFileartisant, text: 'Un solo de jazz <br /> Le premier crack informatique <br /> et un croissant un beurre miam ! @atelierlesbuissoniers' },
    { title: 'La Libanaise', image: libanaiseImage, audioPath: audioFilelibanaise, text: 'La cuisine familialle pleine <br /> La danse d’amour <br /> et le business de vêtements @atelierlesbuissoniers' },
    { title: 'L’amoureux', image: amoureuxImage, audioPath: audioFileamoureux, text: 'Chef de banque en Suisse <br /> Amour de jeunesse <br /> Scootisme @atelierlesbuissoniers' },
    { title: 'Feu', image: feuImage, audioPath: audioFilefeu, text: 'La bandoche et la crème à traire <br /> Peur et réconfort ensoleillé d’une marche sablée .' },
  ];

  useEffect(() => {
    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
      }
      clearTimeout(volumeHideTimeoutRef.current);
    };
  }, []);

  const toggleAudio = (index, audioPath) => {
  // Si on clique sur le même son, on met en pause
  if (playingIndex === index) {
    if (audioRef.current) {
      audioRef.current.pause();
    }
    setPlayingIndex(null);
    return;
  }

  // Si un autre son joue, on le stoppe
  if (audioRef.current) {
    audioRef.current.pause();
    audioRef.current.currentTime = 0;
    audioRef.current.removeEventListener('timeupdate', updateProgress);
  }

  // Crée un nouvel audio et joue-le seulement quand il est prêt
  const newAudio = new Audio(audioPath);
  newAudio.volume = volume;
  newAudio.addEventListener('timeupdate', updateProgress);
  newAudio.addEventListener('loadedmetadata', () => {
    setDuration(newAudio.duration);
    newAudio.play().catch(error => {
      console.error("Audio playback failed:", error);
    });
  });
  audioRef.current = newAudio;
  setPlayingIndex(index);
};

  const updateProgress = () => {
    setCurrentTime(audioRef.current.currentTime);
    setProgress((audioRef.current.currentTime / audioRef.current.duration) * 100);
  };

  const handleSeek = (e) => {
    if (!audioRef.current || !audioRef.current.duration) return;
    const rect = e.currentTarget.getBoundingClientRect();
    let clientX;
    if (e.touches && e.touches.length > 0) {
      clientX = e.touches[0].clientX;
    } else {
      clientX = e.clientX;
    }
    const offsetX = clientX - rect.left;
    const newTime = (offsetX / rect.width) * audioRef.current.duration;
    if (isFinite(newTime)) {
      audioRef.current.currentTime = newTime;
      setCurrentTime(newTime);
    }
  };

  const handleVolumeChange = (e) => {
    const newVolume = e.target.value;
    if (audioRef.current) {
      audioRef.current.volume = newVolume;
    }
    setVolume(newVolume);
    clearTimeout(volumeHideTimeoutRef.current);
    startHideVolumeTimer();
  };

  const startHideVolumeTimer = () => {
    volumeHideTimeoutRef.current = setTimeout(() => {
      setShowVolumeControl(false);
    }, 3000);
  };

  const toggleVolumeBar = () => {
    const newState = !showVolumeControl;
    setShowVolumeControl(newState);
    if (newState) {
      clearTimeout(volumeHideTimeoutRef.current);
      startHideVolumeTimer();
    }
  };

  const formatTime = (time) => {
    if (isNaN(time)) return "0:00";
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60).toString().padStart(2, '0');
    return `${minutes}:${seconds}`;
  };

  // Ouvre la popup avec le contenu donné
  const openPopup = (popupData) => {
    setPopupContent(popupData);
    setPopupVisible(true);
  };

  // Ferme la popup
  const closePopup = () => {
    setPopupVisible(false);
    setPopupContent("");
  };

  // Sépare le texte de description du tag popup pour les afficher sur des lignes différentes
  const renderDescriptionText = (text) => {
    const words = text.split(" ");
    let popupToken = null;
    const textWithoutPopup = words.filter(word => {
      if (word.startsWith("@") && popupDescriptions[word]) {
        popupToken = word;
        return false;
      }
      return true;
    }).join(" ");

    return (
      <>
        <p
          className="description-text"
          dangerouslySetInnerHTML={{ __html: textWithoutPopup }}
        ></p>
        {popupToken && (
          <p className="popup-trigger" onClick={() => openPopup(popupDescriptions[popupToken])}>
            {popupToken}
          </p>
        )}
      </>
    );
  };

  return (
    <div className="scroll-section" id="sound-examples">
      <h6 className="section-title">Podcast</h6>
{/* filepath: c:\Users\Valentin\mon-site\src\Podcast.js */}
<h5 className="header-subtitle">
  <a 
    href="https://www.instagram.com/melodioguem_/"
    target="_blank"
    rel="noopener noreferrer"
  >
    Dessins de Mélodie Gogué-Meunier
  </a>
</h5>
      <div className="sound-examples">
        {soundExamples.map((example, index) => (
          <div 
            key={index} 
            className={`sound-example ${playingIndex === index ? 'playing' : ''}`} 
            onClick={() => toggleAudio(index, example.audioPath)} // Ajout de l'événement onClick ici
          >
            <div className="thumbnail-container">
              <img 
                src={example.image} 
                alt={example.title} 
                className={`thumbnail ${playingIndex === index ? 'playing' : ''}`}
              />
              <div className="icon">
                {playingIndex === index ? <FaPause /> : <FaPlay />}
              </div>
            </div>
            {/* Accordéon regroupant le titre et la description */}
            <div className={`accordion ${playingIndex === index ? 'expanded' : 'collapsed'}`}>
              <p className="title">{example.title}</p>
              {renderDescriptionText(example.text)}
            </div>
          </div>
        ))}
      </div>

      {playingIndex !== null && (
        <div className="mini-player">
          <div className="player-controls">
            <button onClick={() => toggleAudio(playingIndex, soundExamples[playingIndex].audioPath)}>
              {playingIndex !== null ? <FaPause /> : <FaPlay />}
            </button>
          </div>
          <div 
            className="progress-container" 
            onClick={handleSeek}
            onTouchStart={handleSeek}
            onTouchMove={handleSeek}
          >
            <span className="time">{formatTime(currentTime)}</span>
            <div className="progress-bar">
              <div className="progress" style={{ width: `${progress}%` }}></div>
              <div className="slider-handle" style={{ left: `${progress}%` }}></div>
            </div>
            <span className="time">{formatTime(duration)}</span>
          </div>
          <div 
            className="volume-container"
            onMouseEnter={() => clearTimeout(volumeHideTimeoutRef.current)}
            onMouseLeave={startHideVolumeTimer}
            onTouchEnd={startHideVolumeTimer}
          >
            <div className="volume-icon" onClick={toggleVolumeBar}>
              <FaVolumeUp style={{ color: '#ff9800', cursor: 'pointer' }} />
            </div>
            {showVolumeControl && (
              <div className="volume-slider visible">
                <input 
                  type="range" 
                  min="0" 
                  max="1" 
                  step="0.01" 
                  value={volume} 
                  onChange={handleVolumeChange} 
                  className="vertical-slider"
                />
              </div>
            )}
          </div>
        </div>
      )}
      {/* Popup Modal (cliquez n'importe où dans la popup pour la fermer) */}
      {popupVisible && (
        <div className="popup" onClick={closePopup}>
          <div className="popup-content">
            <h2>{popupContent.title}</h2>
            <small>{popupContent.content}</small>
          </div>
        </div>
      )}
    </div>
  );
};

export default SoundExample;
